import { useHierarchyArea } from '@plarium/hierarchy-react';
import React, { useMemo } from 'react';

import { Grid, Alert } from '@gogame/components';

import { MEDIA_SOURCE } from 'scenes/Affiliates/components/AffiliateForm/constants';
import { loadMediaSources } from 'scenes/Affiliates/sources/fields';

import MediaSourceField from './MediaSourceField';

const validate = (value) => {
  if (!value || !Object.keys(value).length) {
    return 'Media source is required';
  } else if (!value.name) {
    return 'Custom source is required';
  }
};

const MediaSource = ({
  value,
  initialValue,
  customSourceHelperText,
  required,
}) => {
  const { data, loading } = useHierarchyArea({
    name: MEDIA_SOURCE,
    source: loadMediaSources,
  });

  const selectedMediaSourceIsConstant = useMemo(() => {
    return value && data?.some(({ id }) => id === value.id);
  }, [value, data]);

  return (
    <React.Fragment>
      <Grid item xs={8}>
        <MediaSourceField
          name={MEDIA_SOURCE}
          data={data}
          loading={loading}
          selectedMediaSourceIsConstant={selectedMediaSourceIsConstant}
          initialValue={initialValue}
          customSourceHelperText={customSourceHelperText}
          validate={required ? validate : null}
          required={required}
          padding={0}
        />
      </Grid>
      {!initialValue && selectedMediaSourceIsConstant ? (
        <Grid item xs={12}>
          <Alert severity={'warning'}>
            Please note that you won't be able to change the media source once
            it is saved.
          </Alert>
        </Grid>
      ) : null}
    </React.Fragment>
  );
};

export default MediaSource;
